/**
 * WordPress dependencies
 */
import domReady from '@safe-wordpress/dom-ready';

type Callback = Parameters< typeof domReady >[ 0 ];

export function appendSibling(
	newNode: HTMLElement,
	existingNode: HTMLElement
): void {
	if ( existingNode.parentNode ) {
		existingNode.parentNode.insertBefore(
			newNode,
			existingNode.nextSibling
		);
	}
}

export function onElementReadyOrDomReadyTops(
	selector: string,
	fn: Callback
): void {
	const checkInterval = 100;
	let availableTime = 2000;

	const check = () => {
		if ( ! availableTime ) {
			domReady( fn );
			return;
		}

		availableTime = Math.max( 0, availableTime - checkInterval );
		if ( ! document.querySelector( selector ) ) {
			setTimeout( check, checkInterval );
			return;
		}

		fn();
	};

	check();
}
